import React, {Fragment, useState} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import setAlert from '../../actions/setAlert';
import {register} from '../../actions/auth';
import PropTypes from 'prop-types';
import {REGISTER} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";

const Register = ({setAlert, register, isAuthenticated, match}) => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        password: '',
        role: 'Agent',
    });
    const [errors, setErrors] = useState({});

    const {first_name, last_name, email, password, mobile, role} = formData;

    const onChange = (e) =>
        setFormData({...formData, [e.target.name]: e.target.value});
    const handleFromValid = () => {
        const {first_name, last_name, email, password, mobile, role} = formData;
        let errors = {};
        let formIsValid = true;

        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

        if (!first_name) {
            formIsValid = false;
            errors.first_name = "*Please Enter your First Name...!";
        }
        if (!last_name) {
            formIsValid = false;
            errors.last_name = "*Please Enter your Last Name...!";
        }
        if (!mobile) {
            formIsValid = false;
            errors.mobile = "Please Enter Your Mobile";
        } else if (mobile.length < 10) {
            formIsValid = false;
            errors.mobile = "Please Enter Valid Mobile Number...!";
        }
        else if (mobile.length > 16) {
            formIsValid = false;
            errors.mobile = "Mobile Number is Not Valid!";
        }

        // Email Validation
        if (!email) {
            formIsValid = false;
            errors.email = "*Please Enter Your Email";
        } else if (!validEmailRegex.test(email)) {
            formIsValid = false;
            errors.email = "*Please Enter Valid Email...!";
        }
        if (!password) {
            formIsValid = false;
            errors.password = "*Please Enter your Password...!";
        }

        setErrors(errors);
        return formIsValid;
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (handleFromValid()) {
            const request = {
                name: first_name + " " + last_name,
                email,
                mobile,
                password,
                refId: match.params.ref_id,
                role

            };
            register(request)
        }

    };

    if (isAuthenticated) {
        return <Redirect to="/private-chat"/>;
    }

    console.log(errors);
    console.log(match.params.ref_id, "params");
    return (
        <Fragment>
            <div className="card w-50 mt-5 mx-auto">
                <h5 className="card-header">Join Us</h5>
                <div className="card-body">
                    <form onSubmit={onSubmit}>
                        <div className="form-check-inline">
                            <label className="form-check-label" htmlFor="radio1">
                                <input type="radio" className="form-check-input" id="radio1" name="role"
                                       value="Agent" onChange={onChange} checked/>Agent
                            </label>
                        </div>
                        <div className="form-check-inline">
                            <label className="form-check-label" htmlFor="radio2">
                                <input type="radio" className="form-check-input" id="radio2" name="role"
                                       value="User" onChange={onChange}/>User
                            </label>
                        </div>
                        <div className="form-group mt-2">
                            <label>First name</label>
                            <input type="text" className="form-control" placeholder="First Name" name="first_name"
                                   value={first_name} onChange={onChange}/>
                            {errors.first_name && <span className="text-danger small">{errors.first_name}</span>}
                        </div>
                        <div className="form-group">
                            <label>Last name</label>
                            <input type="text" className="form-control" placeholder="Last Name" name="last_name"
                                   value={last_name} onChange={onChange}/>
                            {errors.last_name && <span className="text-danger small">{errors.last_name}</span>}
                        </div>
                        <div className="form-group">
                            <label>Mobile</label>
                            <input type="number" className="form-control" placeholder="Mobile" name="mobile"
                                   value={mobile} onChange={onChange}/>
                            {errors.mobile && <span className="text-danger small">{errors.mobile}</span>}
                        </div>

                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" className="form-control" placeholder="Enter Email" name="email"
                                   value={email} onChange={onChange}/>
                            {errors.email && <span className="text-danger small">{errors.email}</span>}
                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <input type="password" className="form-control" placeholder="Enter password" name="password"
                                   value={password} onChange={onChange}/>
                            {errors.password && <span className="text-danger small">{errors.password}</span>}
                        </div>

                        <button type="submit" className="btn btn-dark btn-lg btn-block">Register</button>
                        <p className="forgot-password text-right">
                            Already registered <Link to="/login">Join Now</Link>
                        </p>
                    </form>
                </div>
            </div>


        </Fragment>
    );
};

Register.propTypes = {
    setAlert: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, {
    setAlert, register
})(Register);
